import {FC, PropsWithChildren} from "react";
import {Container} from "react-bootstrap";
import AppHeader from "./AppHeader";
import AppFooter from "./AppFooter";

interface Props extends PropsWithChildren {};

const AppMainLayout: FC<Props> = (props) => {
    return <Container fluid>
        <AppHeader />
        <div style={{marginTop: "70px"}}></div>
        { props.children }
        <AppFooter/>
    </Container>
}

export default AppMainLayout;
